import cookie from "react-cookies";
import { RIMS_COOKIE_CONSTANTS } from "../constants";

const CURRENT_TENANT_QUERY_KEY = "currentTenantId";

let acTenantId: string | undefined;

export function initAcTenantIdFromQuery(): void {
  const params = new URLSearchParams(window.location.search);
  const currentTenantId = params.get(CURRENT_TENANT_QUERY_KEY);

  if (currentTenantId !== null && currentTenantId !== "") {
    acTenantId = currentTenantId;
    return;
  }

  acTenantId = undefined;
}

export function getAcTenantId(): string | undefined {
  return acTenantId;
}

export function getUserTenantId(): string | undefined {
  const userTenantId = cookie.load(RIMS_COOKIE_CONSTANTS.USER_TENANT_ID);
  return userTenantId ?? undefined;
}

export function getCurrentTenantId(): string | undefined {
  return getAcTenantId() || getUserTenantId();
}
